import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { LocalizedText } from 'bernie-l10n';
import { RouteStore } from 'bernie-core';

import { SearchResultsStore } from 'stores/search-results-store';

import { classNames } from 'uitk-react-utils';
import { UitkLink, UitkLinkTypeSize } from 'uitk-react-link';

import { PlaybackFilterPill } from './playback-filter-pill';

export interface PlaybackFilterProps {
  centerPills?: boolean;
  wrapPills?: boolean;
  searchResults?: SearchResultsStore;
  routeStore?: RouteStore;
  analytics?: any;
}

@inject('searchResults', 'routeStore', 'analytics')
@observer
export class PlaybackFilter extends React.Component<PlaybackFilterProps> {
  private removeAllFilters = () => {
    const { searchResults, routeStore } = this.props;
    searchResults.clearFilters(routeStore);
  };

  public render() {
    const { analytics, routeStore, searchResults, wrapPills, centerPills } = this.props;
    const sortAndFilter = searchResults && searchResults.sortAndFilter;
    const isLoading = searchResults && searchResults.isLoading;
    const pills = (sortAndFilter && sortAndFilter.pills) || [];
    const defaults = sortAndFilter && sortAndFilter.defaults;
    const playbackPills = [];

    const classes = classNames(
      {
        'uitk-scroll-horizontal': !wrapPills,
        'uitk-flex-wrap': wrapPills,
        'uitk-flex-justify-content-center': centerPills,
        'all-l-padding-one': !wrapPills,
      },
      'uitk-flex playback-pill-grid'
    );

    pills.forEach(pill => {
      const playbackFilterPill = (
        <PlaybackFilterPill
          key={`playback-filter-${pill.name}-${pill.value}`}
          pill={pill}
          disabled={isLoading}
          routeStore={routeStore}
          defaults={defaults}
          analytics={analytics}
        />
      );

      playbackPills.push(playbackFilterPill);
    });

    if (playbackPills.length > 0) {
      const a11yHeadingMessage =
        playbackPills.length === 1 ? 'hotels.searchResults.singleFilter.a11yLabel' : 'hotels.searchResults.multiFilters.a11yLabel';

      return (
        <section className={classes}>
          <h3 className="is-visually-hidden">
            <LocalizedText message={a11yHeadingMessage} />
          </h3>
          {playbackPills}
          <AbacusExperiment name="PWA_Remove_all_filters">
            <AbacusControl />
            <AbacusVariant bucket={1}>
              {wrapPills && pills.length > 1 && (
                <div className="all-y-padding-two">
                  <UitkLink
                    type={UitkLinkTypeSize.SMALL}
                    inline={true}
                    onClick={this.removeAllFilters}
                    analytics={analytics && analytics.setupTracker('playback.removeAllFilters', 'Remove all filters applied', null)}
                  >
                    <button disabled={isLoading}>
                      <LocalizedText message="hotels.searchResults.playbackFilter.removeAllFilters.linkText" />
                    </button>
                  </UitkLink>
                </div>
              )}
            </AbacusVariant>
          </AbacusExperiment>
        </section>
      );
    }

    return null;
  }
}
